export enum ContractTypeEnum {
  ERC_721 = "ERC721",
  ERC_1155 = "ERC1155",
}
